import { render, staticRenderFns } from "./TooltipImage.vue?vue&type=template&id=b4c2bd62"
import script from "./TooltipImage.vue?vue&type=script&lang=js"
export * from "./TooltipImage.vue?vue&type=script&lang=js"
import style0 from "./TooltipImage.vue?vue&type=style&index=0&id=b4c2bd62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports